import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiPost } from '@/lib/http/client';
import {
  portfolioQueryKeys,
  portfolioSetMemberRoleUrl,
} from '@/lib/portfolio/api';
import type { PortfolioRole } from '@/lib/portfolio/types';

interface SetMemberRoleParams {
  userId: number;
  roleName: PortfolioRole;
}

export function useSetMemberRole(portfolioId: number, orgId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, roleName }: SetMemberRoleParams) =>
      apiPost(portfolioSetMemberRoleUrl(portfolioId, orgId, userId), {
        role_name: roleName,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: portfolioQueryKeys.orgMembers(portfolioId, orgId),
      });
    },
  });
}
